import { Box, Typography, Divider } from "@mui/material";
import { Edit, Notes, ShoppingCart } from "@mui/icons-material";

const getIcon = (type) => {
  switch (type) {
    case "edit":
      return <Edit fontSize="small" />;
    case "note":
      return <Notes fontSize="small" />;
    case "shopping_cart":
      return <ShoppingCart fontSize="small" />;
    default:
      return null;
  }
};

const PurchaseOrderTimeline = ({ events }) => {
  return (
    <Box sx={{ p: 2 }}>
      {events.map((event, index) => (
        <Box key={index} sx={{ display: "flex", mb: 2 }}>
          <Box sx={{ width: 80, textAlign: "right", pr: 2 }}>
            <Typography variant="body2">{event.time}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <Box
              sx={{
                bgcolor: "#e3e6f0",
                borderRadius: "50%",
                p: 1,
                mr: 2,
                mt: "2px",
              }}
            >
              {getIcon(event.icon)}
            </Box>
            <Box>
              <Typography variant="body2">{event.description}</Typography>
              <Typography variant="caption" color="text.secondary">
                by {event.user} on {event.date}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
      <Divider />
    </Box>
  );
};
export default PurchaseOrderTimeline;

// // Usage
//   <PurchaseOrderTimeline events={timelineEvents} />;
